import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import style from './index.scss'

const PageWrapper = ({ children }) => {
  return (
    <div
      className={classnames(style.page_wrapper)}
    >
      {children}
    </div>
  )
}

PageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  close: PropTypes.func,
  fullscreen: PropTypes.bool
}

export default (PageWrapper)
